import request from '@/utils/request';
/**
 * 查询酒店所有硬件设备状态
 * @param hotelCode
 */
export function getHotelHardwareEnable(hotelCode) {
  return request({
    url: `/hardware/hotel/relations/${hotelCode}`,
    method: 'get',
  });
}

/**
 * 根据lockId查询制订的房间信息(门卡读卡)
 * @param lockId
 * @param params
 */
export function getRoomInfoByLockId(lockId, params = {}) {
  return request({
    url: `/hardware/hotel/relations/${lockId}/readCard`,
    method: 'get',
    params,
  });
}

/**
 * 记录硬件操作日志
 * @param data
 * @returns {AxiosPromise}
 */
export function logOperator(data) {
  return request({
    url: '/hardware/log/operator',
    method: 'post',
    data,
    notCheckRepeat: true,
  });
}

/**
 * 根据房间id查询房态信息
 * @param roomId
 */
export function byRoomIdGetRoomInfo(roomId) {
  return request({
    url: `/hardware/hotel/relations/${roomId}/lock`,
    method: 'get',
    params: { roomId: roomId },
  });
}

/**
 * 设备开关
 * @param code
 * @param data
 */
export function updateHardwareStatus(code, data) {
  return request({
    url: `/hardware/hotel/relations/${code}/enabled?enabled=${data.enabled}`,
    method: 'put',
    // params:data
  });
}

/**
 * 查询门锁配置详情
 * @param roomId
 * @param params
 */
export function getHotelHardwareConfigList(roomId, params) {
  return request({
    url: `/hardware/room/lock/relations/${roomId}`,
    method: 'get',
    params,
  });
}

/**
 * 获取硬件详情
 * @param typeCode
 */
export function getHardwareBaseInfo(typeCode) {
  return request({
    url: '/hardware/hotel/relations/baseInfo',
    method: 'get',
    params: { typeCode: typeCode },
  });
}

/**
 * 获取传统门锁支持的功能卡类型
 */
export function getTrationialSupportType() {
  return request({
    url: '/hardware/hotel/relations/tradition/supportType',
    method: 'get',
  });
}

/**
 * 获取下拉列表数据
 * @param code
 */
export function getSelectList(code) {
  return request({
    url: '/hardware/dictionaries',
    method: 'get',
    params: { code: code },
  });
}

/**
 * 获取酒店硬件配置列表
 * @param params
 */
export function getHotelHardwareList(params) {
  return request({
    url: '/hardware/hotel/relations',
    method: 'get',
    params: params,
  });
}

/**
 * 获取集团硬件配置列表
 * @param params
 */
export function getGroupLockList(params) {
  return request({
    url: '/hardware/admin/definitions',
    method: 'get',
    params: params,
  });
}

/**
 * 获取酒店门锁与房间关联列表
 * @param data
 */
export function getHardwareRoomList(data) {
  return request({
    url: '/hardware/room/lock/relations',
    method: 'get',
    params: data,
  });
}

/**
 * 批量添加门锁配置
 * @param data
 */
export function createLockConfig(data) {
  return request({
    url: '/hardware/room/lock/relations',
    method: 'post',
    data,
  });
}

/**
 * 更新门锁配置
 * @param roomId
 * @param data
 */
export function updateLockConfig(roomId, data) {
  return request({
    url: `/hardware/room/lock/relations/${roomId}`,
    method: 'put',
    data,
  });
}

/**
 * 删除门锁配置
 * @param roomId
 * @param params
 */
export function deleteLockConfig(roomId, params) {
  return request({
    url: `/hardware/room/lock/relations/${roomId}`,
    method: 'delete',
    params,
  });
}

/**
 * 获取房间列表
 * @param hotelCode
 * @param params
 */
export function getRoomList(hotelCode, params) {
  return request({
    url: `/hardware/hotel/${hotelCode}/rooms`,
    method: 'get',
    params: params,
  });
}

/**
 * 获取酒店所有已设置密码
 * @param data
 */
export function getResetPasswordsList(data) {
  return request({
    url: `/hardware/room/lock/passwords`,
    method: 'get',
    params: data,
  });
}

/**
 * 添加密码
 * @param data
 */
export function createLockPasswords(data) {
  return request({
    url: `/hardware/room/lock/passwords`,
    method: 'post',
    data,
  });
}

/**
 * 修改密码
 * @param id
 * @param data
 */
export function updateLockPasswords(id, data) {
  return request({
    url: `/hardware/room/lock/passwords/${id}`,
    method: 'put',
    data,
  });
}

/**
 * 获取单个密码设置详情
 * @param id
 * @param data
 */
export function getPasswordDetail(id, data) {
  return request({
    url: `/hardware/room/lock/passwords/${id}`,
    method: 'get',
    params: data,
  });
}

/**
 * 密码置失效
 * @param id
 */
export function getPasswordReset(id) {
  return request({
    url: `/hardware/room/lock/passwords/${id}`,
    method: 'delete',
  });
}

/**
 * 根据酒店code查询硬件启用状态,传roomId可以查询房间的硬件配置
 * @param roomId
 * @param typeCode
 */
export function getHardwareUsedStatus({ roomId = '', typeCode = 'traditionalLock' } = {}) {
  return request({
    url: '/hardware/hotel/relations/typeCode',
    method: 'get',
    params: { roomId, typeCode },
  });
}

/**
 * 查询房间密码是否显示
 * @param roomId
 * @param brandCode
 */
export function getLockBrandEnable({ roomId = '', brandCode = '' } = {}) {
  return request({
    url: '/hardware/hotel/relations/brandCode',
    method: 'get',
    params: { roomId, brandCode },
  });
}

/**
 * 获取物业下房间FreeGo门锁状态列表(一次请求最多返回100条)
 * @param nextDeviceId
 */
export function getFreeGoLockList(nextDeviceId = '') {
  return request({
    url: '/hardware/freego/lockList',
    method: 'get',
    params: { nextDeviceId },
  });
}
/**
 * 查询自助机设置信息
 * @param {*} params
 */
export function fetchHardwareListByHotel(params) {
  return request({
    url: '/hardware/hotel/relations/management/list',
    method: 'get',
    params,
  });
}
/**
 * 查询自助机设置信息
 * @param {*} params
 */
export function fetchAiotSetting(params) {
  return request({
    url: '/hardware/aiot/configs/queryConfigSettings',
    method: 'get',
    params,
  });
}
/**
 * 更新自助机设置信息
 * @param {*} data
 */
export function updateAiotSetting(data) {
  return request({
    url: '/hardware/aiot/configs/selfConfigSettings',
    method: 'post',
    data,
  });
}

/**
 * 保存房价牌设置
 * @param params
 * @returns {AxiosPromise}
 */
export function savePriceCardSetting(params) {
  return request({
    url: '/hardware/pricebrand/savePriceBrand',
    method: 'post',
    data: params,
  });
}

/**
 * 获取房价牌设置
 * @returns {AxiosPromise}
 */
export function getPriceCardSetting() {
  return request({
    url: '/hardware/pricebrand/findPriceBrand',
    method: 'get',
  });
}

/**
 * 设置访价牌开
 * @param params
 * @returns {AxiosPromise}
 */
export function switchPriceCard(params) {
  return request({
    url: '/hardware/pricebrand/updateEnable',
    method: 'get',
    params,
  });
}

/**
 * 设置门锁账号和密码
 * @param params
 * @returns {AxiosPromise}
 */
export function setBindLockManufacturer(params) {
  return request({
    url: '/hardware/room/lock/relations/bindLockManufacturer',
    method: 'post',
    data: params,
  });
}


/**
 * 发送密码
 * @param params
 * @returns {AxiosPromise}
 */
export function sendLockPassWord(params) {
  return request({
    url: '/hardware/room/lock/relations/sendLockPassWord',
    method: 'post',
    data: params,
  });
}


/**
 * 重制密码
 * @param params
 * @returns {AxiosPromise}
 */
export function repeatSendLockPassWord(params) {
  return request({
    url: '/hardware/room/lock/relations/repeatSendLockPassWord',
    method: 'post',
    data: params,
  });
}



/**
 * 获取房价牌信息
 * @param params
 * @returns {AxiosPromise}
 */
export function getRoomPriceCards() {
  return request({
    url: '/dynamic/info/roomType/getRoomPriceCards',
    method: 'get',
  });
}

/**
 * 解密房价牌 v2 接口返回的 AES 密文（AES-128-ECB/PKCS7，密钥与展示页一致）
 * Web Crypto API 不支持 ECB，用 CBC(全零 IV) 逐块等价实现
 * @param {string} ciphertext base64 密文
 * @returns {Promise<string>} 解密后的明文 JSON 字符串
 */
function decryptPriceCardData(ciphertext) {
  if (!window.crypto || !window.crypto.subtle) {
    return Promise.reject(new Error('当前环境不支持 AES 解密'));
  }
  const encoder = new TextEncoder();
  const decoder = new TextDecoder();
  return window.crypto.subtle.importKey(
    'raw',
    encoder.encode('qingZhuDynamicIn'),
    { name: 'AES-CBC' },
    false,
    ['encrypt', 'decrypt']
  ).then((cryptoKey) => {
    const bin = Uint8Array.from(atob(ciphertext), (c) => c.charCodeAt(0));
    if (!bin.length || bin.length % 16 !== 0) {
      throw new Error('房价牌密文长度非法');
    }
    const blockCount = bin.length / 16;
    const iv = new Uint8Array(16);
    const target = new Uint8Array(16).fill(0x10);
    const prevC = bin.slice(bin.length - 16, bin.length);
    const padPlain = new Uint8Array(16);
    for (let i = 0; i < 16; i += 1) {
      padPlain[i] = target[i] ^ prevC[i];
    }
    // 构造末块 Z，使 CBC 解密输出的最后一个块为合法 PKCS7 填充，绕过填充校验
    return window.crypto.subtle.encrypt({ name: 'AES-CBC', iv }, cryptoKey, padPlain).then((zBuf) => {
      const z = new Uint8Array(zBuf).slice(0, 16);
      const input = new Uint8Array(bin.length + 16);
      input.set(bin, 0);
      input.set(z, bin.length);
      return window.crypto.subtle.decrypt({ name: 'AES-CBC', iv }, cryptoKey, input).then((outBuf) => {
        const out = new Uint8Array(outBuf);
        const plain = new Uint8Array(bin.length);
        let prev = new Uint8Array(16);
        for (let i = 0; i < blockCount; i += 1) {
          for (let j = 0; j < 16; j += 1) {
            plain[i * 16 + j] = out[i * 16 + j] ^ prev[j];
          }
          prev = bin.slice(i * 16, (i + 1) * 16);
        }
        const pad = plain[plain.length - 1];
        if (pad < 1 || pad > 16) {
          throw new Error('房价牌密文解密失败');
        }
        return decoder.decode(plain.slice(0, plain.length - pad));
      });
    });
  });
}

/**
 * 获取房价牌信息（v2 加密接口，与展示页统一，返回解密后的房价牌数据）
 * @returns {Promise<{code: *, data: object}>} 解密后的房价牌数据
 */
export function getRoomPriceCardsV2() {
  return request({
    url: '/dynamic/info/roomType/v2/getRoomPriceCards',
    method: 'get',
  }).then((res) => {
    if ((res.code === 0 || res.code === '0') && res.data) {
      return decryptPriceCardData(res.data).then((plaintext) => ({
        code: res.code,
        message: res.message,
        data: JSON.parse(plaintext),
      }));
    }
    return res;
  });
}

// 查询门锁制卡记录
export function queryMakeDoorCardLog(params) {
  return request({
    url: '/hardware/room/lock/relations/queryMakeDoorCardLog',
    method: 'get',
    params
  });
}

// 查询当前有效门锁制卡记录
export function queryValidMakeDoorCardLog(params) {
  return request({
    url: '/hardware/room/lock/relations/queryValidMakeDoorCardLog',
    method: 'get',
    params
  });
}

/**
 * pms保存制卡记录	
 * @param params
 * @returns {AxiosPromise}
 */
export function saveMakeDoorCardLog(params) {
  return request({
    url: '/hardware/room/lock/relations/saveMakeDoorCardLog',
    method: 'post',
    data: params,
  });
}

/**
 * pms根据锁号查询房间号	
 * @param params
 * @returns {AxiosPromise}
 */
export function getRoomLockRelation(params) {
  return request({
    url: '/hardware/hotel/relations/getRoomLockRelation',
    method: 'get',
    params,
  });
}

export function getRoomLockRelationMac(params) {
  return request({
    url: '/hardware/hotel/relations/getRoomLockRelationByMac',
    method: 'get',
    params,
  });
}

/**
 * pms 启用储物柜
 * @param params
 * @returns {AxiosPromise}
 */
export function lockerEnabled(params) {
  return request({
    url: '/hardware/hotel/relations/locker/enabled',
    method: 'PUT',
    params,
  });
}

/**
 * 储物柜设置配置/更新
 * @param params
 * @returns {AxiosPromise}
 */
export function lockerConfigSettings(data) {
  return request({
    url: '/hardware/locker/configs/lockerConfigSettings',
    method: 'post',
    data,
  });
}

/**
 * 返回当前酒店储物柜设置
 * @param params
 * @returns {AxiosPromise}
 */
export function showAllLockersAndCellsByHotelCode(data) {
  return request({
    url: '/hardware/locker/showAllLockersAndCellsByHotelCode',
    method: 'post',
    data,
  });
}

/**
 * PMS及轻赢宝储物格存取开门
 * @param params
 * @returns {AxiosPromise}
 */
export function openCellDoor(data) {
  return request({
    url: '/hardware/lockerCell/openCellDoor',
    method: 'post',
    data,
  });
}

/**
 * PMS及轻赢宝储物格存取开门
 * @param params
 * @returns {AxiosPromise}
 */
export function clearCell(data) {
  return request({
    url: '/hardware/locker/clearCell',
    method: 'post',
    data,
  });
}

/**
 * PMS和小程序展示储物柜下所有储物格及其状态
 * @param params
 * @returns {AxiosPromise}
 */
export function showCellsByLocker(data) {
  return request({
    url: '/hardware/lockerCell/showCellsByLocker',
    method: 'post',
    data,
  });
}

/**
 * 获取门锁数据
 * @param code
 */
export function mtLockBrands(params) {
  return request({
    url: '/hardware/definitions/mtLockBrands',
    method: 'get',
    params: params,
  });
}


/**
 * 保存门卡信息
 * @param code
 */
export function saveDoorCardOrder(data) {
  return request({
    url: '/hardware/hotel/relations/rooms/saveDoorCardOrder',
    method: 'post',
    data,
  });
}

// 查询公共区域门锁绑定列表
export function queryPublicAreaLockBindList(params) {
  return request({
    url: '/hardware/publicArea/lock/bindList',
    method: 'get',
    params
  });
}

// 查询某条公共区域配置
export function queryPublicAreaLockBindInfo(params) {
  return request({
    url: '/hardware/publicArea/lock/getBindInfo',
    method: 'get',
    params
  });

}

// 编辑公共区域配置
export function editPublicAreaLockBind(data) {
  return request({
    url: '/hardware/publicArea/lock/editBind',
    method: 'post',
    data,
  });
}

// 删除公共区域配置
export function deletePublicAreaLockBind(data) {
  return request({
    url: '/hardware/publicArea/lock/deleteBindInfo',
    method: 'post',
    data
  });
}

// 查询公共区域类型
export function queryPublicAreaLockType(params) {
  return request({
    url: '/hardware/publicArea/lock/publicAreaType',
    method: 'get',
    params
  });
}

// 查询门锁品牌配置信息
export function queryLockManufacturerKey(params) {
  return request({
    url: '/hardware/publicArea/lock/getLockManufacturerKey',
    method: 'get',
    params
  });
}


// 
// batchDeleteRelations
export function batchDeleteRelations(data) {
  return request({
    url: '/hardware/room/lock/relations/batchDeleteRelations',
    method: 'post',
    data
  });
}
/**
 * pms智能客控设置
 * @param params
 * @returns {AxiosPromise}
 */
export function roomControlEnabled(params) {
  return request({
    url: '/hardware/hotel/relations/roomControl/enabled',
    method: 'PUT',
    params,
  });
}

/**
 * pms智能客控设置
 * @param params
 * @returns {AxiosPromise}
 */
export function saveRoomControlConfig(data) {
  return request({
    url: '/hardware/roomControl/saveRoomControlConfig',
    method: 'post',
    data,
  });
}

// 查询智能客控设置
export function queryRoomControlConfig() {
  return request({
    url: '/hardware/roomControl/queryRoomControlConfig',
    method: 'get',
  });
}

// 查询客控房间列表查询
export function queryRoomConfigList() {
  return request({
    url: '/hardware/roomControl/queryRoomConfigList',
    method: 'get',
  });
}

/**
 * 客控房间配置保存
 * @param params
 * @returns {AxiosPromise}
 */
export function saveRoomConfig(data) {
  return request({
    url: '/hardware/roomControl/saveRoomConfig',
    method: 'post',
    data,
  });
}

/**
 * 房间客控状态刷新
 * @param params
 * @returns {AxiosPromise}
 */
export function refreshRoomPowerState(data) {
  return request({
    url: '/hardware/roomControl/refreshRoomPowerState',
    method: 'post',
    data,
  });
}

// 酒店客控日志查询
export function queryRoomPowerStateLog(params) {
  return request({
    url: '/hardware/roomControl/queryRoomPowerStateLog',
    method: 'get',
    params
  });
}

/**
 * 房态客控操作取电器
 * @param params
 * @returns {AxiosPromise}
 */
export function powerControl(data) {
  return request({
    url: '/hardware/roomControl/powerControl',
    method: 'post',
    data,
  });
}


export function downloadBatchImportLockInfo(params) { // 
  return request({
    url: '/hardware/room/lock/relations/downloadBatchImportLockInfo',
    method: 'post',
    responseType: 'blob',
    params
  })
}


export function batchImportLockInfo(file) {
  return request({
    url: '/hardware/room/lock/relations/batchImportLockInfo',
    method: 'post',
    data: { file }
  })
}

/**
 * pms 启用人脸设备
 * @param params
 * @returns {AxiosPromise}
 */
export function witnessEnabled(params) {
  return request({
    url: '/hardware/hotel/relations/witness/enabled',
    method: 'PUT',
    params,
  });
}


// 查询酒店人脸设备编码
export function getWitnessSn(params) {
  return request({
    url: '/hardware/witness/getWitnessSn',
    method: 'get',
    params
  });
}


// 设置酒店人脸设备编码
export function addWitnessSn(data) {
  return request({
    url: '/hardware/witness/addWitnessSn',
    method: 'post',
    data: data
  })
}

//删除酒店人脸设备编码
export function deleteWitnessSn(params) {
  return request({
    url: '/hardware/witness/delWitnessSn',
    method: 'get',
    params
  });
}
